<template>
  <div style="display:inline-block;" class="search-form" >
    <el-select v-model="bookType" style="width:110px;">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Number,
        default: ''
      }
    },
    data() {
      return {
        options: [
          {label:"10 条/页", value:10},
          {label:"50 条/页", value:50},
          {label:"100 条/页", value:100},
          {label:"150 条/页", value:150},
        ]
      }
    },
    computed: {
      bookType: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('changePageSize', val)
        }
      }
    }
  }
</script>
